import React from 'react';
import styled from 'astroturf/react';
import LightbulbIcon from 'js/design_system/icons/lightbulb_filled.svg';
import _BadgeContainer from "RecommendedPodcastBadge-BadgeContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/RecommendedPodcastBadge.tsx?styleId=BadgeContainer";
import _BadgeText from "RecommendedPodcastBadge-BadgeText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/RecommendedPodcastBadge.tsx?styleId=BadgeText";
import _IconWrapper from "RecommendedPodcastBadge-IconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/podcast_ai/RecommendedPodcastBadge.tsx?styleId=IconWrapper";


const BadgeContainer = /*#__PURE__*/styled("div", null, {
  displayName: "BadgeContainer",
  styles: _BadgeContainer
});

const BadgeText = /*#__PURE__*/styled("span", null, {
  displayName: "BadgeText",
  styles: _BadgeText
});

const IconWrapper = /*#__PURE__*/styled("span", null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
});

/**
 * A badge component to indicate a recommended podcast in the podcast library.
 * Uses turquoise styling with a lightbulb icon to match the Figma design.
 */
export const RecommendedPodcastBadge: React.FC = () => {
  return (
    <BadgeContainer>
      <IconWrapper>
        <LightbulbIcon />
      </IconWrapper>
      <BadgeText>Recommended podcast</BadgeText>
    </BadgeContainer>
  );
};
